import React, { useState } from "react";
import AchievementCard from "./AchievementCard";
import ResultCard from "./AchievementCard";

const AchievementSection1 = () => {
  const [page, setPage] = useState(1);

  return (
    <div id="score">
      <div className=" lg:w-[100%] lg:mt-44 mt-40">
        <AchievementCard row="top" page={page} />
        <AchievementCard row="bottom" page={page} />
      </div>
      <div className=" mt-10 mx-auto  lg:mt-28 flex items-left w-44  justify-evenly cursor-pointer">
        <div
          className={`p-3 border border-blue-400 ${
            page === 1 ? "bg-yellow-500" : ""
          }`}
          onClick={() => {
            setPage(1);
          }}
        >
          1
        </div>
        <div
          className={`p-3 border border-blue-400 ${
            page === 2 ? "bg-yellow-500" : ""
          }`}
          onClick={() => {
            setPage(2);
          }}
        >
          2
        </div>
        <div
          className={`p-3 border border-blue-400 ${
            page === 3 ? "bg-yellow-500" : ""
          }`}
          onClick={() => {
            setPage(3);
          }}
        >
          3
        </div>
        <div
          className={`p-3 border border-blue-400 ${
            page === 4 ? "bg-yellow-500" : ""
          }`}
          onClick={() => {
            setPage(4);
          }}
        >
          4
        </div>
        <div
          className={`p-3 border border-blue-400 ${
            page === 5 ? "bg-yellow-500" : ""
          }`}
          onClick={() => {
            setPage(5);
          }}
        >
          5
        </div>
        <div
          className={`p-3 border border-blue-400 ${
            page === 6 ? "bg-yellow-500" : ""
          }`}
          onClick={() => {
            setPage(6);
          }}
        >
          6
        </div>
      </div>
    </div>
  );
};

export default AchievementSection1;
